// extracted by mini-css-extract-plugin
export var attachmentContainer = "_jh-0";
export var fileList = "_jh-2";
export var removeFileButton = "_jh-1";